import {SubIssuesListItemNestedSubIssuesServerQuery} from '@github-ui/server-persisted-queries'
import type {SubIssuesListItemNestedSubIssuesServerQueryQuery} from '@github-ui/server-persisted-queries/types/SubIssuesListItemNestedSubIssuesServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export const NESTED_SUB_ISSUES_QUERY_KEY_PREFIX = ['issue-viewer', 'nested-sub-issues'] as const

export function nestedSubIssuesQueryKey(owner: string, repo: string, number: number) {
  return [...NESTED_SUB_ISSUES_QUERY_KEY_PREFIX, {owner, repo, number}] as const
}

export async function fetchNestedSubIssues(
  owner: string,
  repo: string,
  number: number,
  signal?: AbortSignal,
): Promise<SubIssuesListItemNestedSubIssuesServerQueryQuery> {
  const response = await reactFetchJSON(
    `/${owner}/${repo}/issues/${number}/nested_sub_issues?queryId=${SubIssuesListItemNestedSubIssuesServerQuery}`,
    {signal},
  )
  if (!response.ok) {
    throw new Error(`Nested sub-issues fetch failed (${response.status})`)
  }

  const json = (await response.json()) as {
    data?: SubIssuesListItemNestedSubIssuesServerQueryQuery
    errors?: unknown[]
  }
  if (json.errors?.length || !json.data) {
    throw new Error('Nested sub-issues query returned errors')
  }

  return json.data
}
